import { Component, HostBinding, Input, OnInit, computed, inject, input } from '@angular/core';

import { BestOddsGuaranteedState, BetState } from '@bpos/v1/my-bets';
import { EpcotConfig, MyBetsConfig, RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';
import { BetContextualDataService } from 'packages/sports/common/betslip/modules/betplacement/services/request/bet-contextual-data.service';

import { EarlyPayoutPickState } from '../../../my-bets-base/models/early-payout-types';
import { MyBetsBet, MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsUtilService } from '../../services/my-bets-util.service';
import { MyBetsTextBadgeModel } from '../badges/my-bets-text-badge.component';
import { ReBetAvailabilityService } from '../re-bet/re-bet-visibility.service';

@Component({
    selector: 'ms-my-bets-multi-bet-card-detail',
    templateUrl: 'my-bets-multi-bet-card-detail.html',
    styleUrl: 'my-bets-multi-bet-card-detail.scss',
    standalone: false,
})
export class MyBetsMultiBetCardDetailComponent implements OnInit {
    @Input({ required: true }) bet: MyBetsBet;
    @Input({ required: true }) myBetsListContext: MyBetsListContext;
    @Input() showIndicator = true;
    @Input() state?: BetState | EarlyPayoutPickState;
    @Input({ required: true }) hideOdds = false;
    @Input() enableFlash?: boolean;
    @Input({ required: true }) betslip: MyBetsBetSlip;
    cashedOut = input(false);
    cancelledBet = input(false);

    private bcdService = inject(BetContextualDataService);
    private bcdSignal = this.bcdService.betContextualDataSignal;

    showTwoUpMarketSignText = computed(
        () =>
            this.bcdSignal()
                ?.get(this.betslip.betslipId)
                ?.some((ep) => ep.optionId === this.bet.optionMarketInfo?.optionId) &&
            !this.cancelledBet() &&
            !this.cashedOut(),
    );

    @HostBinding('class.flash-bets') get settledTab() {
        return (
            this.myBetsListContext.listType &&
            this.myBetsListContext.listType === BetslipListType.Settled &&
            this.rebetVisibilityService.isAvailable(this.myBetsListContext.listType) &&
            this.state === BetState.Open &&
            this.enableFlash
        );
    }

    private bogState?: BestOddsGuaranteedState;
    isEpcotEnabled = false;
    mybetsTextBadgeModel = MyBetsTextBadgeModel;

    constructor(
        public myBetsConfig: MyBetsConfig,
        private racingConfig: RacingConfig,
        private rebetVisibilityService: ReBetAvailabilityService,
        private epcotConfig: EpcotConfig,
        public myBetsUtilService: MyBetsUtilService,
    ) {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    ngOnInit(): void {
        this.bogState = this.bet.participantInfo ? this.bet.participantInfo.bestOddsGuaranteedState : BestOddsGuaranteedState.NotEligible;
    }

    get isBOGVisible(): boolean {
        return this.racingConfig.isBOGEnabled && this.bogState !== BestOddsGuaranteedState.NotEligible;
    }

    get isBOGNotPaidOut(): boolean {
        return this.bogState === BestOddsGuaranteedState.NotPaidOut;
    }
}
